import { render, staticRenderFns } from "./WorkflowInvocationOutputDownload.vue?vue&type=template&id=b66f1920&scoped=true&"
import script from "./WorkflowInvocationOutputDownload.vue?vue&type=script&lang=js&"
export * from "./WorkflowInvocationOutputDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66f1920",
  null
  
)

export default component.exports